import { render, staticRenderFns } from "./SubHireList.vue?vue&type=template&id=dda6c972"
import script from "./SubHireList.vue?vue&type=script&lang=js"
export * from "./SubHireList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports